module.exports = __webpack_public_path__ + "img/paysec.f3108f47.svg";